// src/components/img/GalerySectionVessels/VesselOrpheus.tsx
import React from 'react';
import vesselImage from './orpheus.jpeg';

const VesselOrpheus: React.FC = () => (
  <img src={vesselImage} alt="Vessel Orpheus" />
);

export default VesselOrpheus;